// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-specified-ton {
    background: #FFFFFF;
    width: 180px;
    height: 68px;
    color: #4CAF50;
    border: 2px solid #4CAF50;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 2px;
}
.input-specified-ton .specified-ton-text {
    text-align: left;
    font-size: 14px;
    font-weight: 700;
    width: 45%;
}
.div-row {
    display: flex;
    flex-direction: row;
}
.input-ton {
    font-size: 24px;
    font-weight: 700;
    width: 80%;
    background-color: #ffffff;
    border: 0;
    outline: none;
}
.span-ton {
    font-size: 24px;
    font-weight: 700;
    text-align: right;
    width: 10%;
    color: #000000;
}
.span-text-requested{
    margin-right: 25px;
    color: #858585;
    font-size: 14px;
    font-weight: 500;
}
.edit-button {
    background-color: #FFFFFF;
    border: none;
    border-radius: 10px;
    color: #4CAF50;
    font-size: 14px;
    font-weight: 600;
}
.donwload-button {
    background-color: #fafafa;
    border: none;
    color: #4CAF50;
    font-size: 14px;
    font-weight: 600;
}
.save-edit-only {
    margin-left: 55%;
}
`, "",{"version":3,"sources":["webpack://./src/components/buttons-request-ton/input-specified-ton/input-specified-ton.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,yBAAyB;IACzB,SAAS;IACT,aAAa;AACjB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;IACV,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB","sourcesContent":[".input-specified-ton {\n    background: #FFFFFF;\n    width: 180px;\n    height: 68px;\n    color: #4CAF50;\n    border: 2px solid #4CAF50;\n    border-radius: 10px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-between;\n    padding: 2px;\n}\n.input-specified-ton .specified-ton-text {\n    text-align: left;\n    font-size: 14px;\n    font-weight: 700;\n    width: 45%;\n}\n.div-row {\n    display: flex;\n    flex-direction: row;\n}\n.input-ton {\n    font-size: 24px;\n    font-weight: 700;\n    width: 80%;\n    background-color: #ffffff;\n    border: 0;\n    outline: none;\n}\n.span-ton {\n    font-size: 24px;\n    font-weight: 700;\n    text-align: right;\n    width: 10%;\n    color: #000000;\n}\n.span-text-requested{\n    margin-right: 25px;\n    color: #858585;\n    font-size: 14px;\n    font-weight: 500;\n}\n.edit-button {\n    background-color: #FFFFFF;\n    border: none;\n    border-radius: 10px;\n    color: #4CAF50;\n    font-size: 14px;\n    font-weight: 600;\n}\n.donwload-button {\n    background-color: #fafafa;\n    border: none;\n    color: #4CAF50;\n    font-size: 14px;\n    font-weight: 600;\n}\n.save-edit-only {\n    margin-left: 55%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
